import { create } from "zustand";
import {
  sectionClockUnchanged,
  type SectionClockState,
} from "@trainrr/api/workout-sections";

type SectionClockUpdater =
  | SectionClockState
  | null
  | ((prev: SectionClockState | undefined) => SectionClockState | null);

type SectionClockStore = {
  sectionClocks: Record<string, SectionClockState>;
  setSectionClock: (sectionId: string, updater: SectionClockUpdater) => void;
  patchSectionClocks: (
    updater: (
      current: Record<string, SectionClockState>,
    ) => Record<string, SectionClockState>,
  ) => void;
  resetSectionClocks: () => void;
};

export const useSectionClockStore = create<SectionClockStore>((set) => ({
  sectionClocks: {},
  setSectionClock: (sectionId, updater) =>
    set((state) => {
      const prev = state.sectionClocks[sectionId];
      const next = typeof updater === "function" ? updater(prev) : updater;
      if (next == null) {
        if (!(sectionId in state.sectionClocks)) return state;
        const { [sectionId]: _removed, ...rest } = state.sectionClocks;
        return { sectionClocks: rest };
      }
      if (prev && sectionClockUnchanged(prev, next)) return state;
      return {
        sectionClocks: {
          ...state.sectionClocks,
          [sectionId]: next,
        },
      };
    }),
  patchSectionClocks: (updater) =>
    set((state) => {
      const next = updater(state.sectionClocks);
      return next === state.sectionClocks ? state : { sectionClocks: next };
    }),
  resetSectionClocks: () => set({ sectionClocks: {} }),
}));
